import { MessageTag, ReplyVerifyingMessage } from "../general";

export class ResetUserPasswordRequest extends ReplyVerifyingMessage {
    public tag : MessageTag = MessageTag.REQ_RESET_USER_PASSWORD;
      public static tag : MessageTag = MessageTag.REQ_RESET_USER_PASSWORD;
    
      /**
     * Construct a new {@link ResetUserPasswordRequest}.
     */
    constructor (
      public objectId: number,
      public password: string,
    )
    {
      super();
    }
  }


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/reset-user-password-request.ts